import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormService } from 'app/services/form.service';

@Component({
  selector: 'app-substance-binds-names',
  templateUrl: './substance-binds-names.component.html',
  styleUrls: ['./substance-binds-names.component.scss']
})
export class SubstanceBindsNamesComponent implements OnInit {
  @ViewChild('substanceBindingInfoInput') substanceBindingInfoInput!: ElementRef;
  substanceBindingInfo!: string

  constructor(private formService: FormService) {}

  ngOnInit(): void {
    this.substanceBindingInfo = this.currentForm.get('substanceBindingInfo')?.value;
  }

  public clearSubstanceBindingInfoInputField() {
    this.substanceBindingInfo = '';
    this.currentForm.patchValue({ 'substanceBindingInfo': '' });
  }

  public updateSubstanceBindingInfo(event: Event) {
    if (event && event.type === 'blur') {
      var target = document.activeElement;
      if (target && target.nodeValue === "cancel") {
        this.substanceBindingInfo = '';
      }
    }
    this.currentForm.patchValue({ 'substanceBindingInfo': this.substanceBindingInfo });
  }

  public cancelUpdate() {
    this.substanceBindingInfo = this.currentForm.get('substanceBindingInfo')?.value;
  }

  get isSubstanceBindsToTarget(): boolean {
    const bindValue = this.currentForm.get('substanceBindsToTarget');

    if(bindValue === undefined || bindValue === null) {
      this.clearSubstanceBindingInfoInputField();
      return false;
    }

    let value: boolean;
    if(typeof bindValue.value === 'string') {
      value = bindValue.value.toUpperCase() === 'YES';
    } else {
      value = !bindValue.value;
    }
    
    if (!value) {
      this.clearSubstanceBindingInfoInputField();
    }

    return value;
  }

  get currentForm(): FormGroup {
    return this.formService.getCurrentUsanFormValue();
  }

}
